export default __webpack_public_path__ + "static/media/redeem-bonus1-m-2.f5c25b05.webp";